import { useShallow } from 'zustand/react/shallow';
import { useSportStore } from '../../model';

export const useSportById = (sportId?: number) => useSportStore(
  useShallow(state => sportId ? state.list.find(sport => sport.id === sportId) : undefined)
);
